import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { ShieldCheck } from 'lucide-react';
export function OfferSection() {
  return <section id="offer-section" className="py-12 md:py-24 bg-mint relative overflow-hidden" data-id="element-165">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl relative z-10" data-id="element-166">
        <div className="bg-white rounded-2xl md:rounded-3xl shadow-2xl overflow-hidden flex flex-col md:flex-row" data-id="element-167">
          {/* Image Side */}
          <div className="md:w-2/5 bg-sage/10 p-4 md:p-8 flex items-center justify-center relative" data-id="element-168">
            <div className="absolute inset-0 bg-gradient-to-br from-sage/20 to-transparent pointer-events-none" data-id="element-169"></div>
            <img src="https://cdn.magicpatterns.com/uploads/kxzMxXAmgQv1NttwpamgJT/heylloyd-image-1775063615406.png" alt="Protocolo SOS 72H" className="w-full max-w-[200px] md:max-w-xs rounded-xl shadow-lg relative z-10 transform -rotate-2" data-id="element-170" />
          </div>

          {/* Content Side */}
          <div className="md:w-3/5 p-5 md:p-12 flex flex-col justify-center text-center md:text-left" data-id="element-171">
            <FadeIn data-id="element-172">
              <h2 className="text-2xl md:text-4xl font-bold mb-3 md:mb-6 text-forest" data-id="element-173">
                Tu transformación comienza hoy
              </h2>
              <p className="text-base md:text-lg text-gray-600 mb-4 md:mb-8 leading-relaxed" data-id="element-174">
                Recupera tu abdomen plano y tu energía hoy mismo por una
                fracción de lo que cuesta una consulta nutricional o un
                suplemento de moda que no funciona. Accede al sistema completo
                ahora.
              </p>

              <div className="mb-4 md:mb-8 p-4 md:p-6 bg-mint/30 rounded-xl md:rounded-2xl border border-mint inline-block w-full md:w-auto" data-id="element-175">
                <p className="text-xs md:text-sm text-gray-500 uppercase tracking-wider font-semibold mb-1" data-id="element-176">
                  Oferta Especial
                </p>
                <div className="flex items-baseline justify-center md:justify-start gap-2 md:gap-3" data-id="element-177">
                  <span className="text-xl md:text-2xl text-gray-400 line-through font-serif" data-id="element-178">
                    $17,99
                  </span>
                  <span className="text-4xl md:text-5xl font-bold text-forest font-serif" data-id="element-179">
                    $6,39
                  </span>
                </div>
                <p className="text-xs md:text-sm text-sage font-semibold mt-1" data-id="element-180">
                  ¡Ahorra un 64%!
                </p>
              </div>

              <div className="flex flex-col items-center md:items-start gap-3" data-id="element-181">
                <Button className="w-full md:w-auto" data-id="element-182" />
                <div className="flex items-center gap-2 text-xs md:text-sm text-gray-500" data-id="element-183">
                  <ShieldCheck className="w-4 h-4 text-sage" data-id="element-184" />
                  <span data-id="element-185">Descarga instantánea en PDF. Acceso de por vida.</span>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}